<template>
  <LawAssistant />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LawAssistant from "../../components/Apps/LawAssistant/index.vue";

export default defineComponent({
  name: "LawAssistantPage",
  components: {
    LawAssistant,
  },
});
</script>
